<template>
<!--<v-autocomplete chips multiple flat solo persistent-hint-->
<!--v-model="model"-->
<!--:items="items"-->
<!--:loading="loading"-->
<!--:search-input.sync="search"-->
<!--:label="label"-->
<!--:placeholder="placeholder"-->
<!--:hint="hint"-->
<!--:hide-details="hideDetails"-->
<!--item-value="id" item-text="name_real"-->
<!--return-object-->
<!--clearable-->
<!--:menu-props="{transition:'scale-transition', 'offset-y': ''}"-->
<!--&gt;-->
<!--<template v-slot:selection="data">-->
<!--<v-chip :selected="data.selected" class="text-capitalize" close small @input="remove(data.item)">-->
<!--{{data.item.name}}-->
<!--</v-chip>-->
<!--</template>-->
<!--<template v-slot:item="data">-->
<!--<template>-->
<!--<v-list-item-content>-->
<!--<v-list-item-title class="text-capitalize"> {{data.item.name}}</v-list-item-title>-->
<!--</v-list-item-content>-->
<!--</template>-->
<!--</template>-->
<!--</v-autocomplete>-->

<v-autocomplete chips multiple flat solo persistent-hint deletable-chips v-model="model" :items="items" :loading="loading" :search-input.sync="search" :label="label" :placeholder="placeholder" :hint="hint" :hide-details="hideDetails" item-text="name_real"
    item-value="id" return-object clearable>
</v-autocomplete>
</template>

<script>
export default {

    name: `im-place-search`,

    props: {
        places: Array,
        label: String,
        placeholder: String,
        hint: String,
        hideDetails: Boolean
    },

    data() {
        return {
            model: [],
            items: [],
            loading: false,
            search: null,
            search_timeout: 300
        };
    },

    watch: {

        search(val) {
            clearTimeout(this.search_timeout);
            this.search_timeout = setTimeout(this.getItems(val), 300);
        },

        places(val) {
            this.model = this.places;
            this.items = this.places;
        }
    },


    methods: {

        // remove(item) {
        //   const index = this.model.indexOf(item.id);
        //   if (index >= 0) this.model.splice(index, 1);
        //   // this.getItems();
        // },

        getItems(val) {
            // quit early if no search value
            if(!val) {
                return;
            }

            // loading
            this.loading = true;

            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === "true" ? "https://" : "http://";
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + "/api/services-new/places/places";

            // prepare params
            let params = {
                params: {
                    search: val,
                    fields: ['id', 'name_real', 'search_text'],
                    size: 5,
                    order: ['hits'],
                    dir: ['desc'],
                    // country: "ro"
                }
            };

            // make places search request
            this.$axios
                .get(endpoint, params)
                .then(response => {
                    response.data.data.forEach(item => {
                        if(this.items.indexOf(item) === -1) {
                            this.items.push(item);
                        }
                    });
                    // this.items = response.data.data;
                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        reset() {
            this.search = null;
            this.items = [];
        }
    }
};
</script>
